module.exports = __webpack_public_path__ + "img/74.9945b1a8.jpg";